import React from "react";
import AddDashboards from "./sections/addDashboards";
import InYour from "./sections/inYour";
import SectionWhiteLabel from "./sections/sectionWhiteLabel";
import "./whiteLabel.scss";
import Letsgo from "../connectors/letsgo";

function WhiteLabel() {
  return (
    <div className="container-white-label">
      <div className="section-white-label">
        <SectionWhiteLabel />
      </div>
      <div className="section-add-dashboards">
        <AddDashboards />
      </div>
      <div className="section-in-your">
        <InYour />
      </div>
      <div className="section-lets-go">
        <Letsgo />
      </div>
    </div>
  );
}

export default WhiteLabel;
